import { useAppDispatch } from 'hooks';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as actions from '../../../actions/actionCatalog';
import { getFileIgnore } from 'reducers/selectors';
import { useSelector } from 'react-redux';

type FileIgnorePopupType = {
  onConfirm: () => void;
  setToIgnoreItem: (arg0: String) => void;
};

const FileIgnorePopup = ({ onConfirm, setToIgnoreItem }: FileIgnorePopupType) => {
  const dispatch = useAppDispatch();
  const fileIgnore = useSelector(getFileIgnore);

  return (
    <Modal show={fileIgnore.popups.showConfirmationPopup}>
      <Modal.Header>
        <Modal.Title>Ignore file</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You are going to permanently ignore the selected file, it will become hidden and won&apos;t be processable anymore.
        </p>
        <p>Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ minWidth: '5em' }}
          variant="outline-secondary"
          onClick={() => {
            dispatch({ type: actions.IGNORE_FILE_QUEUED_ITEM_ABORT });
            setToIgnoreItem('');
          }}
        >
          Cancel
        </Button>
        <Button
          style={{ minWidth: '5em' }}
          variant="danger"
          onClick={() => {
            onConfirm();
            dispatch({ type: actions.IGNORE_FILE_QUEUED_ITEM_FULFILLED });
            setToIgnoreItem('');
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileIgnorePopup;
